import { useEffect, useRef } from 'react';

import { getRwg, setRwg, stampRwgShop } from './rwgStore';

type SearchParams = Record<string, string | string[] | undefined>;

const readString = (
  value: string | string[] | undefined,
): string | undefined => {
  const first = Array.isArray(value) ? value[0] : value;
  if (typeof first === 'string' && first.length > 0) return first;
  return undefined;
};

/**
 * Captures the `rwg_token` Google attaches to a Reserve with Google booking
 * link, and records the shop segment on screen at the time. Mirrors
 * `useCaptureAttribution` and is called from the same place in the root layout,
 * so it sees web URLs and native deep links alike.
 *
 * The shop is stamped separately from the token because the two do not always
 * arrive together: the token is on the landing URL, while the shop segment is a
 * route param that can resolve a render later. SQR-16105.
 */
export const useCaptureRwg = (params: SearchParams): void => {
  const token = readString(params.rwg_token);
  const shopId = readString(params.shopRoute);
  const lastToken = useRef<string | null>(null);

  useEffect(() => {
    if (token && lastToken.current !== token) {
      lastToken.current = token;
      if (getRwg()?.token !== token) {
        setRwg({ token, shopId, capturedAt: Date.now() });
        return;
      }
    }

    if (shopId) stampRwgShop(shopId);
  }, [token, shopId]);
};
